import { ProgressBar, UIText2 } from '@cian/ui-kit';
import { IconActionClose12 } from '@cian/ui-kit-design-tokens/icons';
import { clsx } from 'clsx';
import * as React from 'react';

import * as styles from './CookiesNotification.css';
import { ProgressTimerContainer } from '../../containers/ProgressTimerContainer';

interface ICookiesNotificationProps {
  isTimerAvailable: boolean;
  noResize?: boolean;
  isMobile?: boolean;
  onAgreementView(): void;
  onClose(): void;
}

export const CookiesNotification: React.FC<ICookiesNotificationProps> = ({
  isTimerAvailable,
  noResize,
  isMobile,
  onAgreementView,
  onClose,
}) => {
  const [isVisible, setIsVisible] = React.useState(true);

  const handleAgreementView = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    onAgreementView();
  };

  React.useEffect(() => {
    if (!isVisible) {
      setTimeout(() => {
        onClose();
      }, 300);
    }
  }, [isVisible]);

  return (
    <div
      // onPointerDown останавливаем всплытие
      // чтобы модалки не закрывало (например онбординги) при клике "вне" на банер с куками
      // тк банер выше всех модалок по z-index
      onPointerDown={e => e.stopPropagation()}
      className={clsx(
        styles['container'],
        noResize && styles['desktop-only'],
        !noResize && styles['adaptive'],
        !isVisible && styles['fade-out'],
      )}
      data-testid="cookies-notification"
    >
      <div className={styles['wrapper']}>
        <div className={styles['text']}>
          <UIText2>
            Мы используем {!isMobile && 'куки-файлы. '}
            <a href="#" className={styles['agreement']} onClick={handleAgreementView}>
              {isMobile ? 'куки-файлы' : 'Соглашение об использовании'}
            </a>
          </UIText2>
        </div>
        <button
          data-testid="cookies-notification-close"
          className={styles['close']}
          title="Закрыть"
          onClick={() => setIsVisible(false)}
        >
          <IconActionClose12 display="block" color="icon-primary-default" />
        </button>
      </div>
      {isTimerAvailable ? <ProgressTimerContainer setIsVisible={setIsVisible} /> : <ProgressBar value={0} />}
    </div>
  );
};
